import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {Panel, Section} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {ResizeEvent} from '@mintdata-wsp/wsp/ui/components/resizable/Resizer';

const styles = require('./PanelView.less');
const cx = classnames.bind(styles);

export type OnPanelResize = (resizeEvent:ResizeEvent)=>void;

export interface PanelContentProps
{
    onPanelResize?:(listener:OnPanelResize)=>(void);
}

export interface PanelViewProps extends PanelContentProps
{
    section:Section;
    panel:Panel;
}

@observer
export class PanelView extends React.Component<PanelViewProps, any>
{
    render()
    {
        const {panel} = this.props;
        const element = panel.getElement();

        const newProps = Object.assign({}, element.props, {onPanelResize:this.props.onPanelResize});
        return React.cloneElement(element, newProps);
    }
}











